import axios from '@axios'
import { API_URL } from '../../../conf/environment';
export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchMenu(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get(`${API_URL}/navigation`, { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    }
}
}
